export default __webpack_public_path__ + "static/media/me.8141cff5.jpg";